"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentListWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var DocumentListModal_1 = require("./DocumentListModal");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var DocumentListWidget = /** @class */ (function (_super) {
    __extends(DocumentListWidget, _super);
    function DocumentListWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    DocumentListWidget.prototype.componentDidMount = function () {
        var _this = this;
        if (services_1.resourcesHelper.THEME !== "Britannia") {
            this.customerPortalService
                .getOptionalExtrasInformation(this.props.engine.getInteraction().agreementNumber)
                .subscribe(function (optionalExtraChanges) {
                _this.setState({
                    addedMLEDate: (0, commonFunctions_1.latestCoverChangeDate)(optionalExtraChanges, services_1.OptionalExtras.LEGAL_EXPENSES),
                    addedBDIDate: (0, commonFunctions_1.latestCoverChangeDate)(optionalExtraChanges, [services_1.OptionalExtras.BREAKDOWN_COVER_LOCAL, services_1.OptionalExtras.BREAKDOWN_COVER_UK, services_1.OptionalExtras.BREAKDOWN_COVER_EU])
                });
            });
        }
    };
    DocumentListWidget.prototype.render = function () {
        var _a, _b;
        return ((0, jsx_runtime_1.jsxs)("div", { id: this.props.question.name, className: "documents-widget documents-output-widget ".concat(this.getSetting("cssClass", "")), children: [this.props.question.label ? ((0, jsx_runtime_1.jsx)("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18", children: this.props.question.label })) : "", this.getSetting("helpText", undefined) ? ((0, jsx_runtime_1.jsx)("p", { children: this.getSetting("helpText", "") })) : "", (0, jsx_runtime_1.jsx)(DocumentListModal_1.DocumentListModal, { productName: this.props.interaction.product, policyDate: this.getPolicyStartDate(), isBDIVisible: this.props.interaction.optionalExtras.breakdownCover, isMLEVisible: this.props.interaction.optionalExtras.motorLegalExpenses, addedBDIDate: this.state.addedBDIDate || new Date((_a = this.props.interaction.headerInfo) === null || _a === void 0 ? void 0 : _a.startDate), addedMLEDate: this.state.addedMLEDate || new Date((_b = this.props.interaction.headerInfo) === null || _b === void 0 ? void 0 : _b.startDate), isAccordion: false, coverTier: this.props.interaction.coverTier })] }));
    };
    DocumentListWidget.prototype.getPolicyStartDate = function () {
        var _a, _b;
        return ((_b = (_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.factors) === null || _b === void 0 ? void 0 : _b.renewalQuoteDate) ?
            new Date(this.props.interaction.factors.renewalQuoteDate) :
            new Date(this.props.interaction.factors.originalQuoteDate);
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], DocumentListWidget.prototype, "customerPortalService", void 0);
    return DocumentListWidget;
}(plugin_journey_1.WidgetBase));
exports.DocumentListWidget = DocumentListWidget;
//# sourceMappingURL=DocumentListWidget.js.map